export default __webpack_public_path__ + "static/media/signup.de48c514.png";